import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/octicons/octicons/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "https://www.npmjs.org/package/@primer/octicons-react"
      }}><img parentName="a" {...{
          "src": "https://img.shields.io/npm/v/@primer/octicons-react.svg",
          "alt": "npm version"
        }}></img></a></p>
    <h2>{`Install`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`npm install @primer/octicons-react
`}</code></pre>
    <h2>{`Usage`}</h2>
    <h3>{`Icons`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`@primer/octicons-react`}</inlineCode>{` module exports individual icons as `}<a parentName="p" {...{
        "href": "https://ponyfoo.com/articles/es6-modules-in-depth#named-exports"
      }}>{`named
exports`}</a>{`. This
allows you to import only the icons that you need without blowing up your
bundle:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from 'react'
import {BeakerIcon, ZapIcon} from '@primer/octicons-react'

export default function Icon({boom}) {
  return boom ? <ZapIcon /> : <BeakerIcon />
}
`}</code></pre>
    <p>{`If you were to compile this example with a tool that supports `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Glossary/Tree_shaking"
      }}>{`tree-shaking`}</a>{`
(such as Webpack, Rollup, or Parcel) the resulting bundle would only include
the "zap" and "beaker" icons.`}</p>
    <h3>{`Vertical alignment`}</h3>
    <p>{`By default the octicons have `}<inlineCode parentName="p">{`vertical-align: text-bottom;`}</inlineCode>{` applied as inline
styles. You can change the alignment via the `}<inlineCode parentName="p">{`verticalAlign`}</inlineCode>{` prop, which can be
either `}<inlineCode parentName="p">{`middle`}</inlineCode>{`, `}<inlineCode parentName="p">{`text-bottom`}</inlineCode>{`, `}<inlineCode parentName="p">{`text-top`}</inlineCode>{`, or `}<inlineCode parentName="p">{`top`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {RepoIcon} from '@primer/octicons-react'

export default () => (
  <h1>
    <RepoIcon verticalAlign="middle" /> github/github
  </h1>
)
`}</code></pre>
    <h3><inlineCode parentName="h3">{`aria-label`}</inlineCode></h3>
    <p>{`You have the option of adding accessibility information to the icon with the
`}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-label"
      }}><inlineCode parentName="a">{`aria-label`}</inlineCode>{` attribute`}</a>{` via the `}<inlineCode parentName="p">{`aria-label`}</inlineCode>{` prop.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// Example usage
import {PlusIcon} from '@primer/octicons-react'

export default () => (
  <button>
    <PlusIcon aria-label="Add new item" /> New
  </button>
)
`}</code></pre>
    <h3><inlineCode parentName="h3">{`tabIndex`}</inlineCode></h3>
    <p>{`You can add the `}<inlineCode parentName="p">{`tabindex`}</inlineCode>{` attribute to an SVG element via the `}<inlineCode parentName="p">{`tabIndex`}</inlineCode>{` prop if the SVG element is intended to be interactive.
`}<inlineCode parentName="p">{`tabIndex`}</inlineCode>{` prop also controls the `}<inlineCode parentName="p">{`focusable`}</inlineCode>{` attribute of the SVG element which is defined by SVG Tiny 1.2 and only implemented in
Internet Explorer and Microsoft Edge.`}</p>
    <p>{`If there is no `}<inlineCode parentName="p">{`tabIndex`}</inlineCode>{` prop is present (default behavior), it will set the `}<inlineCode parentName="p">{`focusable`}</inlineCode>{` attribute to `}<inlineCode parentName="p">{`false`}</inlineCode>{`. This is helpful
for preventing the decorative SVG from being announced by some specialized assistive technology browsing modes which can get delayed
while trying to parse the SVG markup.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// Example usage
import {PlusIcon} from '@primer/octicons-react'
export default () => (
  <PlusIcon aria-label="Interactive Plus Icon" tabIndex={0} /> New Item
)
`}</code></pre>
    <h3>{`Sizes`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`size`}</inlineCode>{` prop takes `}<inlineCode parentName="p">{`small`}</inlineCode>{`, `}<inlineCode parentName="p">{`medium`}</inlineCode>{`, and `}<inlineCode parentName="p">{`large`}</inlineCode>{` values that can be used to
render octicons at standard sizes:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Prop`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Rendered Size`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`size='small'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`16px height by `}<inlineCode parentName="td">{`computed`}</inlineCode>{` width`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`size='medium'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`32px height by `}<inlineCode parentName="td">{`computed`}</inlineCode>{` width`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`size='large'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`64px height by `}<inlineCode parentName="td">{`computed`}</inlineCode>{` width`}</td>
        </tr>
      </tbody>
    </table>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// Example usage
import {LogoGithubIcon} from '@primer/octicons-react'

export default () => (
  <h1>
    <a href="https://github.com">
      <LogoGithubIcon size="large" aria-label="GitHub" />
    </a>
  </h1>
)
`}</code></pre>
    <h3>{`Fill`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`fill`}</inlineCode>{` prop takes a string value that can be used to set the color of the icon.
By default, `}<inlineCode parentName="p">{`fill`}</inlineCode>{` is set to `}<a parentName="p" {...{
        "href": "https://css-tricks.com/currentcolor/"
      }}><inlineCode parentName="a">{`currentColor`}</inlineCode></a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// Example usage
import {LogoGithub} from '@primer/octicons-react'
export default () => (
  <h1>
    <a href="https://github.com">
      <LogoGithubIcon fill="#f00" />
    </a>
  </h1>
)
`}</code></pre>
    <h3><inlineCode parentName="h3">{`Octicon`}</inlineCode>{` (DEPRECATED)`}</h3>
    <blockquote>
      <p parentName="blockquote">{`⚠️ The `}<inlineCode parentName="p">{`Octicon`}</inlineCode>{` component is deprecated. Use icon components on their own instead:`}</p>
      <pre parentName="blockquote"><code parentName="pre" {...{
          "className": "language-diff"
        }}>{`- <Octicon icon={AlertIcon} />
+ <AlertIcon />
`}</code></pre>
    </blockquote>
    <p>{`The `}<inlineCode parentName="p">{`Octicon`}</inlineCode>{` component is wrapper that passes props to its icon component. To render a specific icon, you
can pass it either via the `}<inlineCode parentName="p">{`icon`}</inlineCode>{` prop, or as the only child:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Octicon icon={Icon} />
<Octicon><Icon x={10}/></Octicon>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      